module.exports = __webpack_public_path__ + "static/media/pump2.2ef6d68b.jpg";